import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Loan Details ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" ← Back to Loan Calculations ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!
  const _component_BaseLink = _resolveComponent("BaseLink")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_Heading, null, {
      default: _withCtx(() => [
        (_ctx.lender)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.lender) + " - ", 1)
            ], 64))
          : _createCommentVNode("", true),
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_BaseLink, {
      to: "/",
      class: "text-sm"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ]))
}